import Service from "../Service";
import ServiceMember from "../ServiceMember";
import axios from "axios";
import { domain } from "../Constants";
import AuthServiceMember from "../AuthServiceMember";

const profile = {
  getProfileInfo(id) {
    return ServiceMember.get(`api/get-profile-byid?id=${id}`);
    // return AuthServiceMember.get(`api/auth/get-profile-byid?id=${id}`);
    // return Service.get(`api/profile/${id}`);
  },

  createProfileInfo(data) {
    return Service.post(`api/profile`, {
      firstname_th: data.firstname_th,
      lastname_th: data.lastname_th,
      city: data.city,
      brand_name: data.brand_name,
      profession: data.profession,
      design_type: data.design_type,
      email: data.email,
      mobile_number: data.mobile_number,
      website: data.website,
      domain_name: data.domain_name,
      facebook: data.facebook,
      instagram: data.instagram,
      pinterest: data.pinterest,
      avatar: data.avatar ? data.avatar : null,
      cover_url: data.cover_url ? data.cover_url : null,
    });
  },

  updateProfileInfo(data) {
    let edu_param = [];
    let work_param = [];
    switch (data.update_type) {
      case "personal":
        return AuthServiceMember.post(`api/update-profile`, {
          id: data.id,
          // service member
          name_th: data.data.name_th,
          last_th: data.data.last_th,
          email: data.data.email,
          mobile_number: data.data.mobile_number,

          // TCDC Backend
          location: data.data.mem_info.location,
          bio: data.data.mem_info.bio,
          brand_name: data.data.mem_info.brand_name,
          profession: data.data.mem_info.profession,
          design_type: data.data.mem_info.design_type,
          website: data.data.mem_info.website,
          domain_name: data.data.mem_info.domain_name,
          facebook: data.data.mem_info.facebook,
          instagram: data.data.mem_info.instagram,
          twitter: data.data.mem_info.twitter,
          pinterest: data.data.mem_info.pinterest,
          avatar: data.data.mem_info.avatar ? data.data.mem_info.avatar : null,
          cover_url: data.data.mem_info.cover_url
            ? data.data.mem_info.cover_url
            : null,
        });

      case "education":
        // filter empty field
        for (const item of data.data.educations) {
          if (item.school_university) {
            edu_param.push(item);
          }
        }
        return Service.put(`api/educations/${data.id}`, {
          educations: edu_param,
        });

      case "work":
        // filter empty field
        for (const item of data.data.works) {
          if (item.company) {
            work_param.push(item);
          }
        }
        return Service.put(`api/works/${data.id}`, {
          works: work_param,
        });
    }
  },

  uploadImage(image) {
    return axios({
      url: `${domain}api/image-up`,
      method: "POST",
      headers: { "content-type": "multipart/form-data" },
      data: image,
    }).catch((e) => {
      console.log("Catch error on upload an image\n", e.message);
      return { status: e.response.status };
    });
  },
};

export default profile;
